<template>
<div>
    <div class="text-center pt-5 pb-4">
        <p class=""><b>Login your MyPhoneShop Account</b></p>
    </div>
    <v-container class="px-4">
        <v-alert v-if="error_message" class="my-2" :value="true" type="error">
            {{ error_message }}
        </v-alert>
        <v-form ref="loginForm" v-model="valid" @submit.prevent="loginAuthentication">
            <v-text-field
                color="secondary"
                v-model="username"
                label="Email Address/Mobile Number"
                :rules="usernameRules"
                :disabled="loading"
                required>
            </v-text-field>
            <v-text-field
                color="secondary"
                v-model="password"
                type="password"
                label="Password"
                hint="At least 8 characters"
                :rules="[passwordRules.required, passwordRules.min]"
                :disabled="loading"
                required>
            </v-text-field>
            <v-btn block color="secondary" :disabled="loading" :loading="loading" type="submit" dark depressed>Login</v-btn>
        </v-form>
    </v-container>
    <v-container class="custom-v px-4">
        <div class="text-center pb-2">
            <p class=""><b>OR LOGIN WITH</b></p>
        </div>
        <div class="buttons">
            <v-flex>
                <v-btn @click="this.submitFacebookRegistration" color="#3B5998" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-facebook-box</v-icon>
                    <span>Facebook</span>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn @click="this.googleLogin" color="#CC3333" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-google-plus-box</v-icon>
                    <span>Google</span>
                </v-btn>
            </v-flex>
            <v-flex>
                <v-btn @click="this.twitterLogin" color="#1DA1F3" dark depressed block class="text-capitalize">
                    <v-icon class="justify-start">mdi-twitter-box</v-icon>
                    <span>Twitter</span>
                </v-btn>
            </v-flex>
        </div>
<!--        <div class="pt-4">-->
<!--            <v-btn flat to="/register-manual" class="text-capitalize text-decoration" block :ripple="false">Don’t-->
<!--                have an Account Yet? Register here</v-btn>-->
<!--        </div>-->
    </v-container>
    <loader v-show="loading"></loader>
</div>
</template>

<script>
import axios from "axios";

export default
{
    props: {
        addToCart : {
            type : Boolean,
            default : false,
        },
        openCart : {
            type : Boolean,
            default : false,
        },
        eventName: {
            type : String,
            default : 'event',
        },
    },
    data: () => (
    {
        valid: false,
        username: "",
        password: "",
        usernameRules: [
            v => !!v || 'Email Address/Mobile Number is Required',
        ],
        passwordRules: {
            required: value => !!value || 'Required.',
            min: v => (v ? v.length : "") >= 8 || 'Min 8 characters'
        },
        error_message: "",
        loading: false,
    }),
    methods:
    {
        loginAuthentication(clear = false, social = false)
        {
            this.error_message = null
            let req_data = {};

            req_data.username       = this.username;
            req_data.password       = this.password;
            req_data.grant_type     = "password";
            req_data.client_id      = this.$store.state.client_id;
            req_data.client_secret  = this.$store.state.client_secret;
            req_data.scope          = "";

            this.loading            = true;

            axios.post('/oauth/token', req_data).then(res =>
            {
                this.$store.commit('login', res.data);
                this.loading        = false;
                localStorage.setItem('token_type', 'Bearer');
                localStorage.setItem('access_token', res.data.access_token);
                axios.defaults.headers.common['Authorization'] = "Bearer "+ res.data.access_token;

                this.storeUser();
            })
            .catch(err =>
            {
                if (social)
                {
                    this.error_message = "The email address is already use.";
                }
                else
                {
                    this.error_message = err.response.data.message;
                }

                this.loading        = false;
            })
            .finally(()=>{
                // if(!this.error_message)
                // {
                //     var redirect;
                //     redirect = localStorage.getItem('callback_page') ? localStorage.getItem('callback_page') : "";
                //     this.$router.go(-1);
                // }
                if (clear)
                {
                    this.username = null;
                    this.password = null;

                    this.$refs.loginForm.reset();
                }
            });
        },
        storeUser()
        {
            axios.get('/api/user/info')
                .then(res =>{
                    this.$store.commit('store_user',res.data);

                    if (this.addToCart)
                    {
                        EventBus.$emit('addCartOnLogin');
                    }

                    if (this.openCart)
                    {
                        this.$router.replace({path:'/cart'});
                    }

                    // this.$router.replace({path:'/'});
                    //
                    // EventBus.$emit(this.eventName, {data: 'login success'});
                    this.$router.replace({path:'/my-purchase'});
                })
                .catch(err => {
                    this.toaster('something went wrong.', 201);
                })
                .finally(()=>{

                })
        },
        autoLogin()
        {
            if (this.$route.query.status == "success")
            {
                this.username = this.$route.query.email
                this.password = this.$route.query.password

                this.loginAuthentication(true, true)
            }
        },
        submitFacebookRegistration()
        {
            this.loading = true;
            let a = this;

            FB.login(function(response)
            {
                if (response.status === 'connected')
                {
                    // Logged into your app and Facebook.
                    FB.api('/me', {
                        locale: 'en_US',
                        fields: 'id,email,first_name,middle_name,last_name,gender,locale,age_range,picture,address' },
                        function(info)
                        {
                            let req_data = {}

                            req_data.first_name         = info.first_name
                            req_data.last_name          = info.last_name
                            req_data.email              = info.email ? info.email : 'DEFAULT_EMAIL_ADDRESS' + response.authResponse.userID
                            req_data.address            = info.address ? info.address : 'DEFAULT_ADDRESS_ANDROID' + response.authResponse.userID
                            req_data.birthday           = info.birthday ? info.birthday : '1890-04-11'
                            req_data.country_name       = "Philippines"
                            req_data.mobile_number      = "DEFAULT_CONTACT_ANDROID" + response.authResponse.userID
                            req_data.password           = info.email ? info.email + response.authResponse.userID : 'DEFAULT_EMAIL_ADDRESS' + response.authResponse.userID
                            // req_data.facebook_key       = response.authResponse.userID
                            req_data.facebook_key       = info.id
                            req_data.brand_influencer   = localStorage.getItem('current_lead')

                            axios.post('/api/mystory/registration', req_data)
                            .then(response =>
                            {
                                a.status = response.data.status
                                a.username = req_data.facebook_key
                                a.password = req_data.password

                                if (a.status == "success")
                                {
                                    a.loginAuthentication(true, true)
                                }
                                else
                                {
                                    a.loginAuthentication(true, true)
                                }
                            })
                            .catch(err =>
                            {
                                a.status = "Some error occured. Please try again."
                                window.scrollTo(0,0)
                                a.loading = false
                            })
                        }
                    )
                }
                else
                {
                    a.status = "Some error occured. Please try again."
                    window.scrollTo(0,0)
                    a.loading = false
                }
            }, 
            {
                scope: 'email',
                return_scopes: true,
            });
        },
        googleInit()
        {
            (function() {
                var po = document.createElement('script'); po.type = 'text/javascript'; po.async = true;
                po.src = 'https://apis.google.com/js/client.js?onload=onLoadCallback';
                var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(po, s);
            })()
        },
        googleLogin()
        {
            this.loading = true;

            var myParams =
            {
                'clientid' : '536496751992-bi549k1kfu8kh9lb3pe9l868fsmv95pq.apps.googleusercontent.com', //You need to set client id
                'cookiepolicy' : 'single_host_origin',
                'callback' : this.googleLoginCallback, //callback function
                'approvalprompt':'force',
                'scope' : 'email https://www.googleapis.com/auth/plus.login https://www.googleapis.com/auth/plus.profile.emails.read'
            }

            gapi.auth.signIn(myParams)
        },
        googleLoginCallback(googleUser)
        {
            if (googleUser.status.signed_in)
            {
                axios.get('https://www.googleapis.com/oauth2/v1/userinfo?alt=json&access_token=' + googleUser.access_token).then(res =>
                {
                    let req_data = {}

                    req_data.first_name    = res.data.given_name
                    req_data.last_name     = res.data.family_name
                    req_data.email         = res.data.email ? res.data.email : 'DEFAULT_EMAIL_ADDRESS' + res.data.id
                    req_data.address       = res.data.address ? res.data.address : 'DEFAULT_ADDRESS_ANDROID' + res.data.id
                    req_data.birthday      = res.data.birthday ? res.data.birthday : '1890-04-11'
                    req_data.country_name  = "Philippines"
                    req_data.mobile_number = "DEFAULT_CONTACT_ANDROID" + res.data.id
                    req_data.password      = res.data.email ? res.data.email + res.data.id : 'DEFAULT_EMAIL_ADDRESS' + res.data.id
                    req_data.google_key    = res.data.id
                    req_data.brand_influencer = localStorage.getItem('current_lead');

                    axios.post('/api/mystory/registration', req_data)
                    .then(response =>
                    {
                        this.status = response.data.status
                        this.username = req_data.google_key
                        this.password = req_data.password

                        if (this.status == "success")
                        {
                            this.loginAuthentication(true, true)
                        }
                        else
                        {
                            this.loginAuthentication(true, true)
                        }
                    })
                    .catch(err =>
                    {
                        this.status = "Some error occured. Please try again."
                        window.scrollTo(0,0)
                        this.loading = false
                    })
                })
                .catch(err =>
                {
                    this.status = "Some error occured. Please try again."
                    window.scrollTo(0,0)
                    this.loading = false
                })
                .finally(()=>{
                });
            }
            else
            {
                this.status = "Some error occured. Please try again."
                window.scrollTo(0,0)
                this.loading = false
            }
        },
        twitterLogin()
        {
            location.href=process.env.VUE_APP_URL + "twitter/register?login=1"
        },
        twitterCallBack()
        {
            if (this.$route.query.status != "success")
            {
                this.status = this.$route.query.status
            }
        }
    },
    mounted()
    {
        this.autoLogin()
        this.googleInit()
    }
}
</script>

<style lang="scss">
@import "../scss/app.scss";
</style>
